import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useClientsContext } from './Context';
import { Modal } from '../../components/Modal';
import { ShareAgenda } from './Share';
import { useParamsContext } from '../../contexts/ParamsContext';
import ClientesForm from './Form';
import { CLIENTES_TWO_PANE_MIN_WIDTH } from './List';
import { Plus, Send, Share2 } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

const HeaderAction = ({
    icon: Icon,
    label,
    primary = false,
    onClick,
}: {
    icon: LucideIcon;
    label: string;
    primary?: boolean;
    onClick: () => void;
}) => (
    <li className="flex shrink-0 items-center">
        <button
            type="button"
            className={`sf-content-header-button sf-icon-button btn btn-sm btn-circle h-9 min-h-0 w-9 rounded-full p-0 ${primary ? 'is-primary' : ''}`}
            onClick={onClick}
            aria-label={label}
            title={label}
        >
            <Icon className="text-sm" aria-hidden="true" />
        </button>
    </li>
);

export const ActionsClients = () => {
    const { id, setParams } = useParamsContext();
    const { loadClients } = useClientsContext();
    const isTwoPane = useMediaQuery({ minWidth: CLIENTES_TWO_PANE_MIN_WIDTH });
    const [openAdd, setOpenAdd] = useState(false);
    const [openShare, setOpenShare] = useState(false);

    return (
        <>
            {openAdd && (
                <Modal onClose={() => setOpenAdd(false)} title="Novo cliente" desktopClassName="sm:!max-w-xl">
                    <ClientesForm
                        cancel={() => setOpenAdd(false)}
                        callback={() => {
                            setOpenAdd(false);
                            loadClients();
                        }}
                    />
                </Modal>
            )}

            {openShare && (
                <Modal
                    onClose={() => setOpenShare(false)}
                    title="Compartilhar agenda"
                    subTitle="Envie o link para seus clientes agendarem."
                    desktopClassName="sm:!max-w-md"
                >
                    <ShareAgenda />
                </Modal>
            )}

            {/* No celular, o detalhe do cliente aberto ocupa a tela e tem acoes proprias. */}
            {(isTwoPane || !id) && (
                <ul className="flex flex-wrap items-center gap-1.5 sm:gap-2.5">
                    <HeaderAction icon={Plus} label="Adicionar cliente" primary onClick={() => setOpenAdd(true)} />
                    <HeaderAction icon={Share2} label="Compartilhar agenda" onClick={() => setOpenShare(true)} />
                    <HeaderAction
                        icon={Send}
                        label="Mensagem para todos"
                        onClick={() => setParams({ action: 'mensagem-push-all', id: undefined })}
                    />
                </ul>
            )}
        </>
    );
};
